import { useAuth } from "./auth/AuthContext";
import Login from "./pages/Login";
import Shell from "./ui/Shell";
import { OfflineApp } from "./pwa/PwaUi";

export default function App() {
  const { step } = useAuth();
  // Blank while a saved session is looked up, so a reload never flashes the sign-in page.
  if (step.kind === "restoring") return null;
  // A reload with no connection: what was kept on this device, read-only (src/pwa).
  if (step.kind === "offline") return <OfflineApp profile={step.profile} />;
  return step.kind === "signed_in" ? <Shell /> : <Login />;
}
